import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, HostListener, inject, signal, viewChild } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-site-header',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './site-header.html',
  styleUrl: './site-header.scss',
})
export class SiteHeader {
  protected readonly isMenuOpen = signal(false);
  private readonly document = inject(DOCUMENT);
  private readonly menuToggle = viewChild<ElementRef<HTMLButtonElement>>('menuToggle');

  protected toggleMenu(): void {
    this.isMenuOpen.update((isOpen) => !isOpen);
  }

  protected closeMenu(): void {
    this.isMenuOpen.set(false);
  }

  protected selectMenuItem(): void {
    this.closeMenu();
    this.document.defaultView?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }

  @HostListener('document:keydown.escape')
  protected closeMenuWithEscape(): void {
    if (!this.isMenuOpen()) {
      return;
    }

    this.closeMenu();
    this.menuToggle()?.nativeElement.focus();
  }

  @HostListener('window:resize', ['$event'])
  protected closeMenuOnDesktop(event: Event): void {
    const viewport = event.target;

    if (viewport instanceof Window && viewport.innerWidth >= 960) {
      this.closeMenu();
    }
  }
}
